import React from 'react';
import styles from './ServiceCard.module.css';

function ServiceCard({ title, description, imageSrc, features }) {
  return (
    <div className={styles.serviceCard}>
      <div className={styles.imageContainer}>
        <img src={imageSrc || "/images/logo.jpg"} alt={title} className={styles.serviceImage} />
      </div>
      <div className={styles.cardContent}>
        <h3>{title}</h3>
        <p>{description}</p>
        {features && features.length > 0 && (
          <ul className={styles.featuresList}>
            {features.map((feature, index) => (
              <li key={index}>{feature}</li>
            ))}
          </ul>
        )}
      </div>
    </div>

  );
}

export default ServiceCard;
